import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Report } from '../../../shared/_models/Report';
import { Select, Store } from '@ngxs/store';
import { ReportsState } from '../../../shared/stores/reports/reports.state';
import { Observable, Subject } from 'rxjs';
import { ReportsActions } from '../../../shared/stores/reports/reports.actions';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'on-reports-to-sign',
    templateUrl: './reports-to-sign.component.html',
    styleUrls: ['./reports-to-sign.component.scss'],
})
export class ReportsToSignComponent implements OnInit, OnDestroy {
    isLoading = true;

    reportsToSign: Report[];

    @Select(ReportsState.getToSignReportList) reportsToSign$: Observable<
        Report[]
    >;
    destroy$ = new Subject<void>();

    constructor(private store: Store) {}

    ngOnInit() {
        this.store.dispatch(new ReportsActions.IfToSignReportListNeeded());

        this.reportsToSign$
            .pipe(takeUntil(this.destroy$))
            .subscribe((response) => {
                if (response) {
                    this.reportsToSign = response.map((rep) => new Report(rep));
                    this.isLoading = false;
                }
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    reload() {
        this.isLoading = true;
        this.store.dispatch(new ReportsActions.GetToSignReports());
    }
}
